import { ADD_PIXEL, UPDATE_PIXEL, DESTROY_PIXEL, PIXEL_ROLLED, CHANGE_PIXEL_CHARACTER } from '../constants/action-types'
import { SET_PIXEL_CONNECTION_STATUS } from '../actions/pixels'
import { isDev } from '../lib/utils'

const initialState = {
  list: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_PIXEL: {
      const pixel = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          [pixel.pixelId]: pixel
        }
      }
    }
    case UPDATE_PIXEL: {
      const pixel = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          [pixel.pixelId]: pixel
        }
      }
    }
    case DESTROY_PIXEL: {
      const { [action.payload.pixelId]: _, ...rest } = state.list;
      return {
        ...state,
        list: rest
      }
    }
    case PIXEL_ROLLED: {
      const { pixelId, lastRoll } = action.payload;
      if (!state.list[pixelId]) return state;
      return {
        ...state,
        list: {
          ...state.list,
          [pixelId]: {
            ...state.list[pixelId],
            lastRoll
          }
        }
      }
    }
    case CHANGE_PIXEL_CHARACTER: {
      const { pixelId, characterId } = action.payload;
      if (!state.list[pixelId]) return state;
      return {
        ...state,
        list: {
          ...state.list,
          [pixelId]: {
            ...state.list[pixelId],
            characterId
          }
        }
      }
    }
    case SET_PIXEL_CONNECTION_STATUS: {
      const { pixelId, status } = action.payload;
      if (isDev) console.log('[Pixel Debug] Reducer: Setting connection status for pixel', pixelId, 'to', status);

      if (!state.list[pixelId]) {
        if (isDev) console.log('[Pixel Debug] Reducer: Pixel not found in state:', pixelId);
        return state;
      }

      const newState = {
        ...state,
        list: {
          ...state.list,
          [pixelId]: {
            ...state.list[pixelId],
            connectionStatus: status
          }
        }
      };

      if (isDev) console.log('[Pixel Debug] Reducer: Updated state for pixel', pixelId, 'connectionStatus:', newState.list[pixelId].connectionStatus);
      return newState;
    }
    default:
      return state;
  }
}